import "@/panel.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import TransaksiBaru from "@/pages/TransaksiBaru";
import HistoryKoin from "@/pages/HistoryKoin";
import TrainingControl from "@/pages/TrainingControl";
import TrainingResult from "@/pages/TrainingResult";
import DataTraining from "@/pages/DataTraining";
import WebsiteManagement from "@/pages/WebsiteManagement";
import UserManagement from "@/pages/UserManagement";

function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <div style={{ padding: 20 }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<TransaksiBaru />} />
            <Route path="history" element={<HistoryKoin />} />
            <Route path="training-control" element={<Protected roles={["super_admin", "trainer"]}><TrainingControl /></Protected>} />
            <Route path="data-training" element={<Protected roles={["super_admin", "trainer"]}><DataTraining /></Protected>} />
            <Route path="training-result" element={<Protected roles={["super_admin", "trainer"]}><TrainingResult /></Protected>} />
            <Route path="website-management" element={<Protected roles={["super_admin"]}><WebsiteManagement /></Protected>} />
            <Route path="user-management" element={<Protected roles={["super_admin"]}><UserManagement /></Protected>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
